import Modal from 'bootstrap/js/dist/modal';

export default function Modals(modals) {
  const bookReqBtns = document.querySelectorAll('a[data-toggle="#req-book"], button[data-toggle="#req-book"]');

  modals.forEach((el) => {
    el.modal = new Modal(el);
  });

  bookReqBtns.forEach((tBtn) => {
    tBtn.addEventListener('click', (evt) => {
      evt.preventDefault();
      const modalSelector = tBtn.getAttribute('data-toggle');
      const mTitle = tBtn.getAttribute('data-title');
      const mType = tBtn.getAttribute('data-modal-type');
      const formAction = tBtn.getAttribute('data-form-action');
      const modalWnd = document.querySelector(modalSelector);

      if (!modalWnd) return;

      const modalTitle = modalWnd.querySelector('.modal-title');
      const titleObj = JSON.parse(modalTitle.dataset.title);
      const form = modalWnd.querySelector('form');
      const checks = form.querySelectorAll('input.check__input.request-info');
      const checksState = [...checks].map((check) => check.checked);
      const objModal = modalWnd?.modal;
      const dFormAction = form.action;
      form.action += formAction;
      modalTitle.innerHTML = titleObj.company;
      if (mType === 'company') {
        checks[1].checked = true;
      } else if (mType === 'product') {
        modalTitle.innerHTML = titleObj.product + (mTitle || '');
        checks[0].checked = true;
      } else if (mType === 'booking') {
        modalTitle.innerHTML = titleObj.booking + (mTitle || '');
        checks[2].checked = true;
      }

      objModal.show(tBtn);

      function resetModal() {
        form.action = dFormAction;
        checks.forEach((check, index) => {
          check.checked = checksState[index];
        });
      }

      modalWnd.addEventListener('hidden.bs.modal', resetModal);
    });
  });

  document.addEventListener('click', (evt) => {
    const { target } = evt;

    if (!target.classList.contains('invoice-link')) return;

    const invoicePopup = document.querySelector(target.getAttribute('href'));
    const title = invoicePopup.querySelector('.modal-title__details');

    title.innerHTML = target.getAttribute('data-title');
  })
}
